var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pbr-box",staticStyle:{"height":"calc(100vh - 65px)"}},[_c('Header',{ref:"pbrHeader",attrs:{"title":_vm.title,"notice-list":_vm.noticeList}}),_c('keep-alive',[_c('router-view',{staticClass:"pbr-router"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }